import { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { db } from '../lib/firebase';
import { useAuth } from '../contexts/AuthContext';

/**
 * Custom hook to check if the current user is an admin
 * Listens to /admin-users/{userId} in Firebase Realtime Database
 */
export function useAdminStatus() {
  const { currentUser } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminInfo, setAdminInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      console.log('🔐 No current user, not admin');
      setIsAdmin(false);
      setAdminInfo(null);
      setLoading(false);
      return;
    }

    console.log('🔐 Checking admin status for user:', currentUser.uid);
    const adminRef = ref(db, `admin-users/${currentUser.uid}`);

    const unsubscribe = onValue(
      adminRef,
      (snapshot) => {
        const data = snapshot.val();
        console.log('🔐 Admin data from Firebase:', data);
        console.log('🔐 Is admin?', data?.isAdmin === true);
        setIsAdmin(data?.isAdmin === true);
        setAdminInfo(data);
        setLoading(false);
      },
      (error) => {
        console.error('❌ Error checking admin status:', error);
        setIsAdmin(false);
        setAdminInfo(null);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [currentUser]);

  return { isAdmin, adminInfo, loading };
}
